import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { isBrowser } from "react-device-detect";
import ReactStars from "react-rating-stars-component";
import { valoracionLegend } from "../constants/valoracionLegend";

const TalentoCard = ({ talento }) => {
  return (
    <>
      <Card>
        <Card.Body className={"p-20"}>
          <Row>
            <Col xs={isBrowser ? 6 : 12}>
              <Row>
                <Col
                  xs={isBrowser ? 6 : 12}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <span style={{ fontSize: 20 }}>{talento.descripcion}</span>
                </Col>
                <Col xs={isBrowser ? 6 : 12}>
                  {talento.valoracion ? (
                    <div style={{display: 'flex', flexFlow: 'row'}}>
                      <ReactStars
                        count={5}
                        size={25}
                        value={talento.valoracion}
                        activeColor="#00BBEC"
                        edit={false}
                      />
                      <div style={{marginTop: 8, marginLeft: 10}}>
                        {valoracionLegend.find((x) => x.key === talento.valoracion).value}
                      </div>
                    </div>
                  ) : (
                    "No especificado"
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <br />
    </>
  );
};

export default TalentoCard;
